import { useMutation } from "@tanstack/vue-query";

import KiliApi from "@/data/api/kili/kili-api";
import { PasswordRecoveryMutationKeys } from "@/data/api/kili/password-recovery/password-recovery-query-keys";

export type TResetPasswordCommand = {
  email: string;
  newPassword: string;
  recoveryCode: string;
};

export function useResetPasswordMutation() {
  return useMutation({
    mutationKey: PasswordRecoveryMutationKeys.resetPassword(),
    mutationFn: async (body: TResetPasswordCommand) => {
      await KiliApi.resetPassword(
        {
          recoveryCode: body.recoveryCode,
          newPassword: body.newPassword,
        },
        {
          params: {
            email: body.email,
          },
        },
      );
    },
  });
}
